import { LOCALES } from './constants';
import ENGLISH_MESSAGE from './messages/english-message.json';
import JAPANESE_MESSAGE from './messages/japanese-message.json';
import ENGLISH_LABEL from './messages/english-label.json';
import JAPANESE_LABEL from './messages/japanese-label.json';

export const getMultiLanguageLabel = (id, language) => {
    let displayText = '';

    if (!language) {
        language = LOCALES.ENGLISH;
    }

    if (language === LOCALES.ENGLISH) {
        displayText = ENGLISH_LABEL[id];
    } else if (language === LOCALES.JAPANESE) {
        displayText = JAPANESE_LABEL[id];
    }

    if (!displayText) {
        displayText = id;
    }

    return displayText;
};

export const getMultiLanguageMessage = (id, language) => {
    let displayText = '';

    if (!language) {
        language = LOCALES.ENGLISH;
    }

    if (language === LOCALES.ENGLISH) {
        displayText = ENGLISH_MESSAGE[id];
    } else if (language === LOCALES.JAPANESE) {
        displayText = JAPANESE_MESSAGE[id];
    }

    if (!displayText) {
        displayText = id;
    }

    return displayText;
};